module.exports = __webpack_public_path__ + "img/Dantam Makeover 22.7a63263a.jpg";